import axios from 'axios';
import { safetyScoreQuery } from './GQLQueries';

/**
 * Gets the safety data for a user.
 * @param {String} graphQlHubServiceUrl
 * @param {String} username
 * @returns Promise which resolves with the safetyScore data.
 */
const getSafetyDataForUser = async (
  graphQlHubServiceUrl,
  username,
  cancelToken = undefined
) => {
  const response = await axios.post(
    graphQlHubServiceUrl,
    {
      query: safetyScoreQuery,
      variables: { username: username, period: 12 }
    },
    Object.assign(
      {},
      {
        cancelToken: cancelToken
      }
    )
  );

  return response.data.data.safetyScore;
};

export { getSafetyDataForUser };



// WEBPACK FOOTER //
// ./src/apis/SafetyScoreApi.js